import { useTranslate } from '@refinedev/core';
import { Select } from 'antd';
import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import type { ThemeMode } from '@/providers/themeMode';
import { useThemeMode } from '@/providers/themeMode';

const ICONS: Record<ThemeMode, React.ReactNode> = {
  light: <SunOutlined />,
  dark: <MoonOutlined />,
  system: <DesktopOutlined />,
};

/** `LanguageSwitcher` twin for the appearance: light, dark or the OS's. */
export const ThemeModeSwitcher = () => {
  const t = useTranslate();
  const { mode, setMode } = useThemeMode();

  const options = (['light', 'dark', 'system'] as const).map((value) => ({
    value,
    label: t(`theme.${value}`),
  }));

  return (
    <Select
      value={mode}
      onChange={setMode}
      options={options}
      style={{ width: 130 }}
      suffixIcon={ICONS[mode]}
      size="small"
      aria-label={t('theme.label')}
    />
  );
};
